import {API_URL_AU, API_URL_US, API_URL_AE, API_URL_BR} from "../../env"
class Region {
	apiURL: string
	region: string
	regionName: string
	regionNumber: number

	constructor(apiURL: string, name: string, region: string, regionNumber: number) {
		if (apiURL === undefined) {
			throw new Error(`API_URL_${name} is not set`)
		}
		this.apiURL = apiURL
		this.region = region
		this.regionName = name
		this.regionNumber = regionNumber
	}

	url(endpoint: string) {
		return `${this.apiURL}${endpoint}`
	}

	awsRegion() {
		return this.region
	}

	name() {
		return this.regionName
	}

	number() {
		return this.regionNumber
	}
}
const Regions = {
	AU: new Region(API_URL_AU, "AU", "ap-southeast-2", 0),
	US: new Region(API_URL_US, "US", "us-west-2", 1),
	AE: new Region(API_URL_AE, "AE", "me-central-1", 2),
	BR: new Region(API_URL_BR, "BR", "sa-east-1", 3),
} as const

const RegionNumberMap = {
	0: "AU",
	1: "US",
	2: "AE",
	3: "BR",
} as const

export type RegionNumber = keyof typeof RegionNumberMap

export function isRegionNumber(regionNumber: number): regionNumber is RegionNumber {
	return regionNumber in RegionNumberMap
}

class RegionManager {
	region: Region

	constructor(region: Region) {
		this.region = region
	}

	setRegionFromRegionNumber(regionNumber: RegionNumber) {
		this.region = Regions[RegionNumberMap[regionNumber]]
	}

	setRegionFromAWSRegion(awsRegion: string) {
		if (awsRegion === Regions.US.awsRegion()) {
			this.region = Regions.US
		} else if (awsRegion === Regions.AE.awsRegion()) {
			this.region = Regions.AE
		} else if (awsRegion === Regions.BR.awsRegion()) {
			this.region = Regions.BR
		} else {
			this.region = Regions.AU
		}
	}

	setRegionFromSecureCode(secureCode: string) {
		if (secureCode.length === 11 && secureCode[0] === "1") {
			this.region = Regions.US
		} else if (secureCode.length === 11 && secureCode[0] === "2") {
			this.region = Regions.AE
		} else if (secureCode.length === 11 && secureCode[0] === "3") {
			this.region = Regions.BR
		} else {
			this.region = Regions.AU
		}
	}

	getRegion() {
		return this.region
	}

	getRegionNumber() {
		return this.region.number()
	}

	getRegionAWSName() {
		return this.region.awsRegion()
	}

	url(endpoint: string) {
		return this.region.url(endpoint)
	}
}

const regionManager = new RegionManager(Regions.AU)

const setRegionFromSecureCode = regionManager.setRegionFromSecureCode.bind(regionManager)
const setRegionFromAWSRegion = regionManager.setRegionFromAWSRegion.bind(regionManager)
const setRegionFromRegionNumber = regionManager.setRegionFromRegionNumber.bind(regionManager)
const getRegion = regionManager.getRegion.bind(regionManager)
const getRegionAWSName = regionManager.getRegionAWSName.bind(regionManager)
const getRegionNumber = regionManager.getRegionNumber.bind(regionManager)

export {
	setRegionFromSecureCode,
	setRegionFromRegionNumber,
	setRegionFromAWSRegion,
	getRegion,
	getRegionAWSName,
	Regions,
	RegionNumberMap,
	regionManager,
	getRegionNumber,
}
